
import { useState } from 'react';
import { toast } from 'sonner';
import { updateModalLog } from '@/services/modalCampaigns';
import { ModalCampaign } from '@/types/modalCampaigns';

export const useModalDismissal = (
  campaign: ModalCampaign | null,
  quizPassed: boolean,
  score: number = 0,
  onDismiss?: () => void
) => {
  // Calculate whether the user can dismiss the modal
  const canDismiss = (() => {
    if (!campaign) return true;
    
    // If no quiz, can always dismiss if allowed
    if (!campaign.has_quiz) {
      return campaign.allow_dismiss;
    }
    
    // If quiz is required, check if passed based on min_score
    const minScore = campaign.min_score || 0;
    return (score >= minScore) && quizPassed;
  })();

  const dismissModal = async (logId: string | null, permanently: boolean = false) => {
    if (!logId) return;
    
    // Extra safety check: don't allow dismissal if canDismiss is false
    if (!canDismiss) {
      toast.error('Je moet eerst de quiz voltooien voordat je kunt sluiten.');
      return;
    }
    
    try {
      await updateModalLog(logId, permanently);
      
      if (onDismiss) {
        onDismiss();
      }
    } catch (error) {
      console.error('Error dismissing modal:', error);
      toast.error('Er is een fout opgetreden bij het sluiten van de modal');
    }
  };

  return {
    canDismiss,
    dismissModal
  };
};
